export default __webpack_public_path__ + "static/media/2300.c0324730.png";